import React from "react";
import { MapPin } from "lucide-react";
import Reveal from "../Reveal";

const TOWNS = [
  {
    name: "Kennett Square, PA",
    body:
      "Known as the Mushroom Capital of the World, Kennett Square blends a walkable historic downtown with rolling Chester County countryside. Buyers are drawn to its charming Victorians, new construction, and easy access to Longwood Gardens, while sellers benefit from steady demand and a strong sense of community. Roger Minner knows these neighborhoods block by block and helps clients price, market, and negotiate with local insight.",
  },
  {
    name: "West Chester, PA",
    body:
      "West Chester pairs a lively, award-winning borough with quiet tree-lined streets and top-rated schools. From restored townhomes near the courthouse to spacious family homes in surrounding townships, the market moves quickly for well-prepared listings. Whether you are buying your first home or moving up, Roger guides you through West Chester's competitive market with clear strategy and hands-on support.",
  },
  {
    name: "Downingtown, PA",
    body:
      "Downingtown offers a welcoming, commuter-friendly lifestyle along the Brandywine Creek, with highly regarded schools and convenient access to Route 30 and the train. Families appreciate the mix of established neighborhoods and newer developments at approachable price points. Roger helps buyers find the right fit and helps sellers stand out, drawing on deep familiarity with Downingtown and the greater Chester County corridor.",
  },
];

const CommunitiesSection = () => (
  <section className="bg-[#f6f2ed] py-20 md:py-24 border-t border-[#e6ded4]">
    <div className="max-w-[1200px] mx-auto px-6">
      <Reveal className="text-center mb-14 max-w-3xl mx-auto">
        <p className="font-sans-el tracking-[0.4em] uppercase text-[#9a878b] text-xs mb-4">
          Local Expertise
        </p>
        <h2 className="section-title text-3xl md:text-4xl text-[#3a3736] leading-tight">
          Communities We Serve
        </h2>
        <div className="divider-ornament mt-6 mb-6">
          <span className="line" /><span className="dot" /><span className="line" />
        </div>
        <p className="font-serif-el text-xl leading-relaxed text-[#4a4644]">
          Roger Minner helps buyers and sellers throughout the Greater Chester and Delaware Counties.
          Explore a few of the towns where he delivers trusted, hands-on real estate guidance.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-8">
        {TOWNS.map((town) => (
          <Reveal key={town.name}>
            <article className="bg-white rounded-sm p-8 h-full shadow-[0_16px_40px_-28px_rgba(58,55,54,0.35)]">
              <div className="flex items-center gap-3 mb-4">
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#efe4e5] shrink-0">
                  <MapPin size={18} className="text-[#6f5f62]" />
                </span>
                <h3 className="font-serif-el text-2xl text-[#3a3736] leading-tight">{town.name}</h3>
              </div>
              <p className="font-sans-el text-[#4a4644] leading-relaxed">{town.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default CommunitiesSection;
